import element from './plugins/element';
import amount from './plugins/amount';
import utils from './plugins/utils';

// import { library } from '@fortawesome/fontawesome-svg-core';
// import { faCoffee } from '@fortawesome/free-solid-svg-icons';
// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
// library.add(faCoffee);
// Vue.component('fa-icon', FontAwesomeIcon);

const extenal = Vue => {
  Vue.use(element);
  Vue.use(amount);
  Vue.use(utils);
};

export default extenal;
